import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'keen-ui/dist/keen-ui.css';
import './tailwind.css';

import Vue from 'vue';
import VueMq from 'vue-mq';
import VueRouter from 'vue-router';
import { sync } from 'vuex-router-sync';

import App from './App';
import router from './router';
import store from './store';
import validator from './validator';

Vue.use(VueRouter);

Vue.use(VueMq, {
  breakpoints: {
    sm: 640,
    md: 768,
    lg: 1024,
    xl: Infinity,
  },
});

let unsync = sync(store, router);

new Vue({
  el: '#body',
  router,
  store,
  render: h => h(App),
  beforeDestroy() {
    unsync();
  },
});

if (!('localStorage' in window)) {
  window.localStorage = {
    _data: {},
    setItem: function(id, val) { return this._data[id] = String(val); },
    getItem: function(id) { return this._data.hasOwnProperty(id) ? this._data[id] : undefined; },
    removeItem: function(id) { return delete this._data[id]; },
    clear: function() { return this._data = {}; }
  };
}